import {
  AnalyticsEventAction,
  AnalyticsEventType,
} from '@th/shared/src/types/AnalyticsEvent';
import Link from 'next/link';
import * as React from 'react';
import { clsx } from 'clsx';
import logEvent from '../../helpers/mutations/logEvent';
import { useAuthModal } from '../../contexts/AuthModalContext';
import Button from '../Button';

type Props = {
  small?: boolean;
};

export default function UnauthenticatedCarouselOverlay({ small }: Props) {
  const { openAuthModal } = useAuthModal();
  return (
    <div>
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="m-12">
          <div
            className={clsx(
              'flex flex-col bg-white bg-opacity-80 rounded-lg justify-center items-center',
              small ? 'p-2 md:p-4 gap-y-3' : 'p-8 gap-y-4',
            )}
          >
            <h3 className={clsx(small && 'text-sm', 'text-center')}>
              You need to be signed in to see Sold Data
            </h3>
            {!small ? <p>It takes 30 seconds to make an account</p> : null}
            <Button
              onClick={() => {
                logEvent({
                  action:
                    AnalyticsEventAction.clicked_signup_button_in_unauthenticated_carousel_overlay,
                  type: AnalyticsEventType.signup_button_click,
                });
                openAuthModal();
              }}
              title="Sign up"
              textClassName={'font-normal'}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
